import type { ID } from '@octopus-do/octopus-project-core'
import type { AppState } from '@store/types'

import { selectWorkspaceFolders } from './selectWorkspaceFolders'

export const selectFolder = (workspaceId: ID, id: ID) => (state: AppState) =>
  selectWorkspaceFolders(workspaceId)(state).find((f) => f.id === id) || null
